import { PerformanceCard } from '@/components/PerformanceCard';
import { TotalReturnDetails } from '@/components/PerformanceCardsContainer/components/TotalReturnDetails';
import {
  useWorkflowAutomationsPerformance,
  useWorkflowTotalReturn,
} from '@/modules/Workflows/queries/use-workflow-automations-performance';
import { formatNumber } from '@/utils';
import { useMemo, useState } from 'react';
import { DateRange } from 'react-day-picker';
import { useTranslation } from 'react-i18next';

type WorkflowTotalReturnCardProps = {
  workflowId: number;
  automationPerformanceDateRange?: DateRange;
};

export const WorkflowTotalReturnCard = ({
  workflowId,
  automationPerformanceDateRange,
}: WorkflowTotalReturnCardProps) => {
  const { t } = useTranslation();
  const [dateRange, setDateRange] = useState<DateRange>();
  const [searchInput, setSearchInput] = useState<string>();
  const [isDetailsOpen, setDetailsOpen] = useState<boolean>(false);

  const { data: workflowPerformance, isLoading } =
    useWorkflowAutomationsPerformance(
      workflowId,
      automationPerformanceDateRange,
    );

  const {
    data,
    isLoading: isLoadingTotalReturnAutomated,
    fetchNextPage,
    isFetching,
    isFetchingNextPage,
  } = useWorkflowTotalReturn({
    workflowId,
    enabled: isDetailsOpen,
    dateRange,
    filter: searchInput,
  });

  const totalReturnAutomated = useMemo(
    () => data?.pages.flatMap((page) => page) || [],
    [data?.pages],
  );

  return (
    <>
      <PerformanceCard
        key={t('total_return')}
        title={t('total_return')}
        content={[
          {
            title: `${formatNumber(workflowPerformance?.totalReturn || 0)}€`,
          },
          {
            title: `${formatNumber(workflowPerformance?.averageCost ?? 0)}€`,
            subtitle: t('average_return_per_run'),
          },
        ]}
        isLoading={isLoading}
        onExpand={() => setDetailsOpen(true)}
      />
      {isDetailsOpen && (
        <TotalReturnDetails
          isLoading={isLoadingTotalReturnAutomated}
          totalReturnAutomated={totalReturnAutomated}
          onClose={() => setDetailsOpen(false)}
          fetchNextPage={fetchNextPage}
          dateRange={dateRange}
          setDateRange={setDateRange}
          setSearchInput={setSearchInput}
          isFetching={isFetching}
          isFetchingNextPage={isFetchingNextPage}
        />
      )}
    </>
  );
};
